import { Palette } from '../types/palette';
export const NavigationTheme = {
    transparentDarkText: {
        navItemVariant: 'darkTheme',
        activeNavItem: 'activeDarkTheme',
        backgroundColor: Palette.transparent,
        color: Palette.charcoalgray,
        hoverColor: Palette.jade4
    },
    transparentLightText: {
        navItemVariant: 'lightTheme',
        activeNavItem: 'activeLightTheme',
        backgroundColor: Palette.transparent,
        color: Palette.white,
        hoverColor: Palette.grayandrules
    },
    solidNavDarkText: {
        navItemVariant: 'darkTheme',
        activeNavItem: 'activeDarkTheme',
        backgroundColor: Palette.white,
        color: Palette.charcoalgray,
        hoverColor: Palette.jade4
    }
};
export const SolidDarkTheme = 'solidNavDarkText';
//# sourceMappingURL=navigation-theme.js.map